import { render, staticRenderFns } from "./aspectRatio.vue?vue&type=template&id=2b8bce52&scoped=true"
import script from "./aspectRatio.vue?vue&type=script&lang=js"
export * from "./aspectRatio.vue?vue&type=script&lang=js"
import style0 from "./aspectRatio.vue?vue&type=style&index=0&id=2b8bce52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8bce52",
  null
  
)

export default component.exports